export default __webpack_public_path__ + "static/media/g38.37f8eb1c.png";